let displayFormat = 'm/d/yyyy';
let readableDate = d => `${d.getUTCMonth() + 1}/${d.getUTCDate()}/${d.getUTCFullYear()}`;
let serverDate = d => `${d.getUTCFullYear()}-${d.getUTCMonth() + 1}-${d.getUTCDate()}`;
let attachDatepicker = (i, item) => {
    let $item = $(item);
    if ($item.data('datepicker-initialized')) {
        return;
    }

    let oldName = $item.attr('name');
    if (!oldName) {
        return;
    }

    let value = $item.val();
    if (value) {
        let dateValue = new Date(value.toString());
        $item.val(readableDate(dateValue))
    }
    $item.after($(`<input type="hidden" class="datepicker-hidden" name="${oldName}" value="${value}">`));
    $item.attr('name', oldName + '_date');
    $item.on('change', e => {
        let $datePicker = $(e.target);
        let date = Date.parse($datePicker.val().toString());
        if (!isNaN(date)) {
            $datePicker.siblings("input.datepicker-hidden").first().val(serverDate(new Date(date)));
        }
    });
    $item.on('changeDate clearDate', e => {
        let $datePicker = $(e.target);
        let date: Date = (<any>e).date;
        if (date){
            let convertedDate = serverDate(date);
            $datePicker.siblings("input.datepicker-hidden").first().val(convertedDate);
            $datePicker.trigger('date-change');
        }
    });
    let options: any;
    options = { autoclose: true,
        format: displayFormat,
        orientation: "bottom left"};
    let startDate = $item.data('start-date');
    if (startDate) {
        options.startDate = startDate;
    }
    let endDate = $item.data('end-date');
    if (endDate) {
        options.endDate = endDate;
    }
    (<any>$item).datepicker(options);
    $item.data('datepicker-initialized', true);
};

$(document).on("turbo:load turbo:render fieldsAdded", () => {
    $(".datepicker").each(attachDatepicker);
});

$(document).on('click', 'button.datepicker-clear', (e) => {
    e.preventDefault();
    let $container = $(e.currentTarget).closest('.cu-datepicker, .datepick');
    let $datePicker = $container.find('input.datepicker').first();
    $datePicker.val('');
    $container.find('input.datepicker-hidden').first().val('');
    $datePicker.trigger('date-change');
});

$(document).on('addedFields', e => {
    $(e.target).find('.datepicker').each(attachDatepicker);
});